import { createFileRoute, notFound } from '@tanstack/react-router';
import ConfigureProducts from '../../../pages/products/ConfigureProducts';
import { VIEW_PRODUCTS_PAGE } from '../../../utils/permissions';

export const Route = createFileRoute('/_authenticated/_navbar/list-products')({
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_PRODUCTS_PAGE)) {
      throw notFound();
    }
  },
  component: ConfigureProducts,
});
